// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lista-ordinamento {
  margin-bottom: 10px;
}

.titolo-ordinamento {
  margin-top: 10px;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
}

.help-ordinamento {
  font-size: 0.8rem;
  font-weight: 400;
  font-style: italic;
  text-align: left;
  white-space: normal;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/orderpopover/orderpopover.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACJ","sourcesContent":[".lista-ordinamento {\n    margin-bottom: 10px;\n}\n\n.titolo-ordinamento {\n    margin-top: 10px;\n    font-size: 1rem;\n    font-weight: 600;\n    text-align: center;\n}\n\n.help-ordinamento {\n    font-size: 0.8rem;\n    font-weight: 400;\n    font-style: italic;\n    text-align: left;\n    white-space: normal;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
